import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { FieldConfig } from "../../../interfaces/field.interface";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { UserProvider } from "src/app/services/user/user";
import { CadastroProvider } from "src/app/services/cadastro/cadastro";
import { IonicModule, IonSearchbar, NavParams } from "@ionic/angular";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { IonicSelectableComponent } from "ionic-selectable";
@Component({
  selector: "app-multiple-select",
  template: `
    <ion-item [formGroup]="group" (click)="openModal()">
      <div style="width: 100%; display: flex;justify-content: space-between; flex-direction: column;">
        <label class="selected-label">
          {{ field.label ?? "" | translate }}
          <span *ngIf="field.validations && field.validations[0]?.name === 'required'" class="danger">*</span>
        </label>

        <ion-text color="medium" class="edit-text">
          {{ getSelectedLabel() || ('Selecione' | translate) }}
        </ion-text>
      </div>
      <div>
        <ion-icon name="caret-down-outline" slot="end" color="medium" style="font-size: 14px;"></ion-icon>
      </div>
    </ion-item>

    <ion-modal [isOpen]="isModalOpen" (didDismiss)="isModalOpen = false">
      <ng-template>
        <ion-header class="extendido">
          <ion-buttons left>
            <ion-button (click)="closeModal()">
              <i class="fa-regular fa-chevron-left chevron-back-button"></i>
            </ion-button>

            <ion-title>{{ field.label ?? "" | translate }}</ion-title>
          </ion-buttons>
        </ion-header>

        <ion-content>
          <div class="gradient-extendido"></div>

          <ion-searchbar
            #searchbar
            (ionInput)="filter($event)"
            (ionCancel)="cancelar()"
            placeholder="{{ 'Buscar...' | translate }}"
            show-cancel-button="never"
          >
          </ion-searchbar>

          <ion-list>
            <ion-item *ngFor="let opt of filteredOptions" (ionChange)="toggleSelection(opt)">
              <ion-checkbox slot="start" [checked]="Selected(opt)"></ion-checkbox>
              <label>{{ opt.label }}</label>
            </ion-item>

            <ion-item *ngIf="filteredOptions.length === 0">
              {{ "Nenhum Registro Localizado" | translate }}
            </ion-item>
          </ion-list>
        </ion-content>

        <ion-footer>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-button
                  class="btn-custom"
                  expand="block"
                  *ngIf="getSelectedLabel() !== ''"
                  (click)="limparSelecao()"
                >
                  {{ "Limpar" | translate }}
                </ion-button>
              </ion-col>
              <ion-col>
                <ion-button class="btn-custom" expand="block" *ngIf="getSelectedLabel() !== ''" (click)="closeModal()">
                  {{ "Concluir" | translate }}
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-footer>
      </ng-template>
    </ion-modal>

    <div class="validation-errors">
      <ng-container *ngFor="let validation of field.validations">
        <div
          class="error-message"
          *ngIf="
            group.get(field.name)?.hasError(validation.name) &&
            (group.get(field.name)?.dirty || group.get(field.name)?.touched)
          "
        >
          {{ "Campo Obrigatório" | translate }}
        </div>
      </ng-container>
    </div>
  `,
  styles: [
    `
      .edit-text {
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      ion-item {
        --inner-border-width: 0px;
        margin: 0 20px;
        padding: 10px 0;
      }

      .gradient-extendido {
        height: 30px !important;
      }

      ion-searchbar {
        --background: #f7f7f7;
        --color: #000;
        --placeholder-color: #000;
        --icon-color: var(--theme-color4);
        --clear-button-color: #000;
        --border-radius: 24px;
        padding-inline-start: 22px !important;
        padding-inline-end: 22px !important;
      }

      ion-radio {
        --color-checked: var(--theme-color4);
      }

      ion-radio.ios::part(container) {
        width: 20px;
        height: 20px;
        border: 2px solid #ddd;
        border-radius: 10px;
      }

      .radio-checked.ios::part(container) {
        border-color: var(--theme-color4);
      }

      .selected-label {
        white-space: normal !important;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .btn-custom {
        border-radius: var(--theme-border-botao);
      }

      ion-checkbox {
        --size: 24px;
        --background-checked: #0041e8;
      }

      ion-checkbox::part(container) {
        border-radius: 6px;
        border: 2px solid #0041e8;
      }

      .error-message {
        padding-bottom: 10px !important;
        font-size: 12px !important;
      }

      .validation-errors {
        margin-left: 35px;
      }
    `,
  ],
  standalone: true,
  imports: [TranslateModule, IonicModule, ReactiveFormsModule, IonicSelectableComponent, CommonModule],
})
export class MultipleSelectComponent implements OnInit {
  @Input() field: FieldConfig;
  @Input() group: FormGroup;
  @Input() idInstituicao: number;
  @ViewChild("searchbar", { static: false }) searchbar?: IonSearchbar;

  FormGroup: FormGroup;
  searchText: string = "";
  filteredOptions: any[] = [];
  isModalOpen: boolean = false;

  public results = [];

  constructor(
    private formBuilder: FormBuilder,
    public pessoaProvider: PessoaProvider,
    public userProvider: UserProvider,
    public cadastroProvider: CadastroProvider,
    public navParams: NavParams
  ) {
    this.idInstituicao = this.navParams.get("idInstituicao");
    this.FormGroup = this.formBuilder.group({
      profissao: new FormControl("", Validators.required),
    });
  }

  ngOnInit(): void {
    this.filteredOptions = this.field.options ?? [];
  }

  openModal() {
    this.filteredOptions = this.field.options ?? [];
    this.searchText = "";
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  limparSelecao() {
    this.group.get(this.field.name)?.setValue([]);
    this.FormGroup.get("profissao")?.reset();
    this.field.value = [];
  }

  filter(event: Event) {
    const target = event.target as HTMLIonSearchbarElement;
    const query = target.value?.toLowerCase() || "";

    this.searchText = query;

    this.filteredOptions = (this.field.options ?? []).filter((item: any) => item.label.toLowerCase().includes(query));

    if (this.filteredOptions.length === 0 && query.length > 0) {
      this.FormGroup.get("profissao")?.reset();
      this.FormGroup.get("profissao")?.setValue(query);
    }
  }

  Selected(value: any): boolean {
    const selectedValues = this.group.get(this.field.name)?.value || [];
    return selectedValues.includes(value);
  }

  cancelar() {
    this.searchText = "";
    this.filteredOptions = this.field.options ?? [];
    this.FormGroup.get("profissao")?.reset();
    if (this.searchbar) {
      this.searchbar.value = "";
    }
  }

  getSelectedLabel(): string | null {
    const values: any[] = this.group.get(this.field.name)?.value || [];
    const selectedLabels = (this.field.options ?? []).filter((opt) => values.includes(opt)).map((opt) => opt.label);

    return selectedLabels.length > 0 ? selectedLabels.join(", ") : null;
  }

  toggleSelection(select: any): void {
    let selectedValues: any[] = this.group.get(this.field.name)?.value || [];

    if (selectedValues.includes(select)) {
      selectedValues = selectedValues.filter((v) => v !== select);
    } else {
      selectedValues.push(select);
    }

    this.group.get(this.field.name)?.setValue(selectedValues);
  }
}
